import React, { ReactElement } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import WbIncandescentIcon from "@material-ui/icons/WbIncandescent";
interface TipModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  content: string;
}

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: "16px",
    padding: theme.spacing(4),
    maxWidth: "800px",
    position: "relative",
    margin: "unset !important",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
      width: "100%",
      margin: theme.spacing(2),
      borderRadius: "12px",
      padding: theme.spacing(3),
    },
  },
  iconContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: theme.spacing(3),
  },
  iconCircle: {
    width: 120,
    height: 120,
    borderRadius: "50%",
    backgroundColor: "#FEF3E2",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      width: 100,
      height: 100,
    },
  },
  icon: {
    fontSize: 60,
    color: "#E1A731",
    transform: "rotate(180deg)",
    [theme.breakpoints.down("sm")]: {
      fontSize: 50,
    },
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(0, 3, 2),
    fontSize: "24px",
    fontWeight: 700,
    color: "#E1A731",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
      padding: theme.spacing(0, 2, 2),
    },
  },
  closeButton: {
    position: "absolute",
    top: 16,
    right: 16,
    backgroundColor: "#DC2626",
    color: "white",
    width: 36,
    height: 36,
    "&:hover": {
      backgroundColor: "#B91C1C",
    },
  },
  dialogContent: {
    padding: theme.spacing(0, 1, 1),
  },
  contentBox: {
    backgroundColor: "#F3F4F6",
    border: "2px dashed #D1D5DB",
    borderRadius: "8px",
    padding: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },
  contentText: {
    fontSize: "16px",
    lineHeight: "1.6",
    color: "#000000",
    whiteSpace: "pre-line",
  },
}));

const TipModal = ({
  open,
  onClose,
  title,
  content,
}: TipModalProps): ReactElement => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        className: classes.dialogPaper,
      }}
    >
      <IconButton
        aria-label="close"
        className={classes.closeButton}
        onClick={onClose}
        size="small"
      >
        <CloseIcon />
      </IconButton>
      <div className={classes.iconContainer}>
        <div className={classes.iconCircle}>
          <WbIncandescentIcon className={classes.icon} />
        </div>
      </div>
      <DialogTitle className={classes.dialogTitle} disableTypography>
        {title}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <div className={classes.contentBox}>
          <Typography className={classes.contentText}>{content}</Typography>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TipModal;
